module.exports = __webpack_public_path__ + "assets/img/face_contrast_example4.56c194cb.png";